import { useMutation } from '@tanstack/react-query';
import type {
  SubmitLabOrderRequestT,
  SubmitLabOrderResponseT,
} from '@lotushealth/lotushealth_js_sdk/schemas';

import { fetchSubmitLabOrder } from '../api/submitLabOrder.js';

export interface SubmitLabOrderVariables {
  userId: string;
  data: SubmitLabOrderRequestT;
}

export function useSubmitLabOrderMutation() {
  return useMutation({
    mutationKey: ['labs', 'submit-order'],
    mutationFn: async ({
      userId,
      data,
    }: SubmitLabOrderVariables): Promise<SubmitLabOrderResponseT> => {
      return await fetchSubmitLabOrder(userId, data);
    },
  });
}
